module.exports = __webpack_public_path__ + "static/media/qlpp_jdyf_icon@3x.a0bb7922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qlpp_jdyf_icon@3x.png
// module id = 200
// module chunks = 0